import * as React from "react";
import { FixedCommentSetForm } from "../FixedCommentsForm/FixedCommentsForm";
import { FixedCommentSetFormModel, GetModelFromFormState } from "../Types";
import { useHistory } from "react-router-dom";
import { WebPortalClient } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";

const CreateFixedCommentSetScreen = ({ }): JSX.Element => {

    const [isBusy, setIsBusy] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string>();

    const client = useWebPortalApiClient();

    const history = useHistory();
    const { study } = useCurrentStudyConfigurationContext();

    const onSubmit = async(values: FixedCommentSetFormModel) => {
        setIsBusy(true);
        setError(null);

        try {
            const studySets = await client.client.getStudyFixedCommentSets(undefined, `studyId eq ${study.id} and sessionType eq '${values.SessionType}' and commentSetType eq '${values.SetType}'`);
            const model = GetModelFromFormState(values, study.id);

            let studySetId;
            if (studySets.value.length === 0) {
                const postResult = await client.client.postStudyFixedCommentSet({ ...model, fixedCommentSets: undefined });
                studySetId = postResult.id;
            } else {
                studySetId = studySets.value[0].id;
            }

            await client.client.postFixedCommentSet({ ...model.fixedCommentSets[0], studySetId: studySetId });

            setIsBusy(false);
            history.push("/FixedComments");
        } catch (e) {
            setError(e.message);
            setIsBusy(false);
        }
    };

    const initalCommentsFormValues: FixedCommentSetFormModel = {
        EntityType: null,
        SessionType: null,
        SetType: null,
        Comments: {},
        DefaultSelectedComment: null,
        Id: null
    };

    return (
        <FixedCommentSetForm
            editMode={false}
            initalCommentsFormValues={initalCommentsFormValues}
            onSubmit={onSubmit}
            title="Create New Fixed Comments Set"
            error={error}
        />
    );
};


export default CreateFixedCommentSetScreen;
